import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'

/**
 * Schema for resource summary data displayed on index/listing pages.
 * This is the summarized representation of a resource shown in cards,
 * as opposed to the full resource details shown on individual pages.
 */
export const ResourceSummarySchema = z.object({
  heading: z.string().optional(),
  image: safeOptional(
    z
      .object({
        description: z.string().optional().nullable(),
        url: z.string().optional().nullable(),
      })
      .nullable(),
  ),
  path: z.string().optional(),
  description: safeOptional(RichTextSchema.nullable()),
})

export type ResourceSummary = z.infer<typeof ResourceSummarySchema>
